import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../auth/auth.service';
import { ToasterService } from '../../providers/toaster/toaster.service';

@Injectable({
  providedIn: 'root'
})
export class PrivacyPolicyService {
  private apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private toasterService: ToasterService
  ) {}

  getAllPages(): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        return this.http.get(`${this.apiUrl}master/page-getall`, {
          headers,
          observe: 'response'
        });
      }),
      catchError((error) => {
        if (error.status === 401) {
          this.handleTokenExpired();
        }
        return throwError(() => error);
      })
    );
  }

  savePageContent(data: any, pageId?: number | string): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        const url = pageId
          ? `${this.apiUrl}master/page/${pageId}/update`
          : `${this.apiUrl}master/page/store`;

        return this.http.post(url, data, {
          headers,
          observe: 'response'
        });
      }),
      catchError((error) => {
        if (error.status === 401) {
          this.handleTokenExpired();
        }
        return throwError(() => error);
      })
    );
  }

  deletePage(pageId: number | string): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        return this.http.get(`${this.apiUrl}master/page/${pageId}/delete`, {
          headers,
          observe: 'response'
        });
      }),
      catchError((error) => {
        if (error.status === 401) {
          this.handleTokenExpired();
        }
        return throwError(() => error);
      })
    );
  }

  private handleTokenExpired(): void {
    this.toasterService.setToaster(
      'default',
      'Session Expired',
      'The session has expired. Please log in again.'
    );
    this.authService.logout();
  }
}
